import { supabase } from "@/integrations/supabase/client";

export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

export async function uploadOrgAsset(
    file: File,
    path: string
): Promise<string> {
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
        throw new Error('Invalid file type. Only JPG, PNG, and WebP are allowed.');
    }
    if (file.size > MAX_FILE_SIZE) {
        throw new Error('File size exceeds 5MB limit.');
    }

    const { data, error } = await supabase.storage
        .from('org-assets')
        .upload(path, file, {
            upsert: true,
            contentType: file.type
        });

    if (error) {
        throw error;
    }

    return data.path;
}

export async function getSignedUrl(path: string): Promise<string | null> {
    if (!path) return null;

    const { data, error } = await supabase.storage
        .from('org-assets')
        .createSignedUrl(path, 3600); // 1 hour

    if (error) {
        console.error("Error getting signed URL:", error);
        return null;
    }

    return data.signedUrl;
}

export function normalizeImageFileExt(filename: string): string {
    const ext = filename.split('.').pop()?.toLowerCase() || '';
    if (['jpg', 'jpeg'].includes(ext)) return 'jpg';
    if (ext === 'png') return 'png';
    if (ext === 'webp') return 'webp';
    return 'jpg'; // Default fallback
}
